import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { getPeople } from 'services/api/AccessManagerAPI';

// Every person (SLAI staff only). enabled: false holds the request back — for
// anybody else it is a guaranteed 403.
export const useGetPeople = (enabled = true) => {
    const { data, isLoading, ...rest } = useQuery({
        queryKey: queryKeys.people,
        queryFn: getPeople,
        enabled,
    });

    return { peopleData: data, isPeopleLoading: isLoading, ...rest };
};
